import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-blank-admin',
  templateUrl: './block-blank-admin.component.html',
  styleUrls: ['./block-blank-admin.component.scss']
})
export class AtwBlockBlankAdmin implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
